(() => {
  const init=()=>document.querySelectorAll('[data-lch-write-product-review]').forEach(button=>{
    if(button.dataset.collectionReady)return;button.dataset.collectionReady='true';
    button.addEventListener('click',async()=>{
      const status=document.querySelector('[data-review-collection-status]');if(status)status.hidden=false;button.disabled=true;
      try{
        document.querySelector('.lch-native-review-collector')?.classList.add('lch-native-review-collector--activate');
        let link;
        for(let i=0;i<60;i++){
          link=document.querySelector('.lch-native-review-collector .jdgm-write-rev-link');
          if(link)break;
          await new Promise(resolve=>setTimeout(resolve,150));
        }
        if(!link)throw new Error('Review form unavailable');
        link.click();let retried=false,opened=false;
        for(let i=0;i<100;i++){
          const form=document.querySelector('.jdgm-write-review-modal');
          if(form&&form.getBoundingClientRect().width>0){opened=true;break;}
          if(!retried&&i>3&&form){link.click();retried=true;}
          await new Promise(resolve=>setTimeout(resolve,100));
        }
        if(!opened)throw new Error('Review form unavailable');
        if(status)status.hidden=true;
      }catch{if(status){status.textContent=status.dataset.error;status.hidden=false;}}finally{button.disabled=false;}
    });
  });
  init();document.addEventListener('shopify:section:load',init);
})();
